import React, { useState, useEffect } from 'react';

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc: string;
}

export const SafeImage: React.FC<SafeImageProps> = ({ src, fallbackSrc, ...props }) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [src]);

  return (
    <img
      src={error ? fallbackSrc : (src || fallbackSrc)}
      onError={(e) => {
        if (!error) {
          setError(true);
        }
      }}
      {...props}
    />
  );
};
